import type { Locale } from "./routing";

export type Currency = "EUR" | "ILS";

export const currencyMeta: Record<
  Currency,
  { code: Currency; symbol: string; label: string; locale: string }
> = {
  EUR: { code: "EUR", symbol: "€", label: "Euro", locale: "fr-FR" },
  ILS: { code: "ILS", symbol: "₪", label: "Shekel", locale: "he-IL" },
};

export function defaultCurrencyForLocale(locale: Locale): Currency {
  return locale === "he" ? "ILS" : "EUR";
}

export function formatPrice(
  amount: number,
  currency: Currency,
  locale: Locale,
): string {
  const meta = currencyMeta[currency];
  return new Intl.NumberFormat(meta.locale, {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}
